import axios from "../../js/project-axios.js"

const list = () => {
    return axios.get("/product/list", {
        public: true
    });
};

const add = product => {
    return axios.post("/product/add", product);
};

const update = product => {
    return axios.post("/product/update", product);
};

export default {
    list,
    add,
    update
};